<template>
  <vetster-slide-over
    ref="confirmation"
    container-classes=""
    :disable-click-outside="disableClose"
    :disable-close-on-escape="disableClose"
    is-slidein
    @close="cancel"
  >
    <template
      v-if="hasHeader"
      #header
    >
      <vetster-slide-over-common-heading
        :header="header"
        :show-close="!disableClose"
        class="py-2 space-y-2 lg:space-y-5"
        @close="cancel"
      >
        <template
          v-if="icon"
          #header-content
        >
          <fa
            :icon="icon"
            class="text-3xl sm:text-4xl font-light text-bubblegum"
          />
        </template>
      </vetster-slide-over-common-heading>
    </template>
    <template #content>
      <div
        :class="{ 'py-0': hasHeader }"
        class="p-standard"
      >
        <p class="text-base font-normal leading-6 text-neutral-700">
          {{ body }}
        </p>
      </div>
    </template>
    <template #footer>
      <div class="w-full flex justify-end">
        <vetster-slide-over-common-footer
          :primary-action-label="agreeLabel"
          :secondary-action-label="cancelLabel"
          :class="{ 'sm:w-11/12': agreeLabel && cancelLabel }"
          @primary-action="agree"
          @secondary-action="cancel"
        />
      </div>
    </template>
  </vetster-slide-over>
</template>

<script>
import Vue from 'vue';

import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterSlideOverCommonFooter from '@/brand-components/VetsterSlideOverCommonFooter';
import VetsterSlideOverCommonHeading from '@/brand-components/VetsterSlideOverCommonHeading';
import setGlobalProperty from '@/helpers/setGlobalProperty';

export default {
  name: 'VetsterConfirmation',

  components: {
    VetsterSlideOver,
    VetsterSlideOverCommonFooter,
    VetsterSlideOverCommonHeading,
  },

  data() {
    return {
      agreeLabel: this.$t('common.yes'),
      body: '',
      cancelLabel: this.$t('common.no'),
      disableClose: false,
      header: '',
      icon: null,
      isOpen: false,
      resolve: () => {},
      reject: () => {},
    };
  },

  computed: {
    hasHeader() {
      return !!this.header.length;
    },
  },

  watch: {
    isOpen(newValue) {
      if (newValue && !this.$refs.confirmation.isOpen) {
        this.$refs.confirmation.open();
      } else {
        this.$refs.confirmation.close();
      }
    },
  },

  created() {
    setGlobalProperty(Vue, '$confirmDialog', this.open);
  },

  methods: {
    agree() {
      this.resolve(true);
      this.$emit('agree');
      this.close();
    },

    cancel() {
      this.resolve(false);
      this.$emit('cancel');
      this.close();
    },

    close() {
      this.reset();
      this.isOpen = false;
    },

    open(body, options) {
      if (body) {
        this.body = body;
      }

      if (options) {
        Object.keys(options).forEach((key) => {
          if (Object.prototype.hasOwnProperty.call(this, key)) {
            this[key] = options[key];
          }
        });
      }

      this.isOpen = true;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    reset() {
      this.agreeLabel = this.$t('common.yes');
      this.cancelLabel = this.$t('common.no');
      this.body = '';
      this.header = '';
    },
  },
};
</script>
